import { render, staticRenderFns } from "./DirectPayment.vue?vue&type=template&id=63c7983d"
import script from "./DirectPayment.vue?vue&type=script&lang=js"
export * from "./DirectPayment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports